'use client';

import { createContext, useContext } from 'react';

/** Whether visible assistant prose has arrived since the latest user message. */
export const AssistantReplyStartedContext = createContext(false);
export const useAssistantReplyStarted = () =>
  useContext(AssistantReplyStartedContext);

export function hasCurrentAssistantReply(
  messages: readonly {
    role: string;
    text?: string;
    parts?: readonly { type: string; text?: string }[];
  }[]
): boolean {
  for (let index = messages.length - 1; index >= 0; index -= 1) {
    const message = messages[index]!;
    if (message.role === 'user') return false;
    if (
      message.role === 'assistant' &&
      (Boolean(message.text?.trim()) ||
        message.parts?.some(
          (part) => part.type === 'text' && Boolean(part.text?.trim())
        ))
    )
      return true;
  }
  return false;
}
